export default __webpack_public_path__ + "static/media/logouticon.a905592e.svg";